import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-black px-8 py-16 overflow-hidden">
      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-amber-500/5 blur-3xl rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <p
              className="text-white/65 text-sm leading-relaxed mb-6"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              AI 影視動畫・虛擬人 IP 建構<br />商業短視頻解決方案
            </p>

          </div>

          {/* Quick links */}
          <div>
            <h4
              className="text-amber-400/80 text-xs tracking-[0.3em] uppercase mb-6"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              快速連結
            </h4>
            <div className="space-y-3">
              {[
                { id: 'about', label: '關於' },
                { id: 'portfolio', label: '作品' },
                { id: 'effects', label: '服務' },
                { id: 'student-works', label: '學員作品' },
                { id: 'contact', label: '聯絡' },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="block text-white/65 hover:text-amber-400 transition-colors duration-300 text-sm cursor-pointer"
                  style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                >
                  <span className="text-amber-500/50 mr-2">✦</span>{item.label}
                </button>
              ))}
              <button
                onClick={() => navigate('/blog')}
                className="block text-white/65 hover:text-amber-400 transition-colors duration-300 text-sm cursor-pointer"
                style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
              >
                <span className="text-amber-500/50 mr-2">✦</span>教學
              </button>
            </div>
          </div>

          {/* Contact info */}
          <div>
            <h4
              className="text-amber-400/80 text-xs tracking-[0.3em] uppercase mb-6"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              聯絡方式
            </h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-center gap-3 text-white/70">
                <i className="ri-phone-line text-amber-500/70"></i>
                <span style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>+886 987-080-355</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <i className="ri-mail-line text-amber-500/70"></i>
                <span style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>adam.chen0706@gmail.com</span>
              </div>
              <div className="flex items-start gap-3 text-white/70 mt-2">
                <i className="ri-map-pin-line text-amber-500/70 mt-0.5"></i>
                <span style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                  台北市文山區<br />木柵路一段83號
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-amber-500/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Social icons */}
            <div className="flex items-center gap-4">
              {[
                { href: 'https://www.instagram.com/passer_999/', icon: 'ri-instagram-line', label: 'Instagram' },
                { href: 'https://youtube.com', icon: 'ri-youtube-line', label: 'YouTube' },
                { href: 'https://behance.net', icon: 'ri-behance-line', label: 'Behance' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-sm border border-amber-500/20 text-white/40 hover:text-amber-400 hover:border-amber-400/50 transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/20 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>

            <div
              className="text-white/55 text-sm"
              style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
            >
              © 2025 四相AI影視學院. All rights reserved.
            </div>

            <div className="flex items-center gap-6">
              {[
                { href: '#privacy', label: '隱私政策' },
                { href: '#terms', label: '使用條款' },
                { href: 'https://readdy.ai/?ref=logo', label: 'Website Builder', external: true },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener noreferrer' : undefined}
                  className="text-white/55 hover:text-amber-400 transition-colors duration-300 text-sm cursor-pointer"
                  style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
